import React, {useState, useRef, useEffect} from 'react'
import deleteButton from '../../../../../../_metronic/images/deleteButton.svg'
import editButton from '../../../../../../_metronic/images/editButton.svg'
import {Mention, MentionsInput} from 'react-mentions'
import {ITagList} from '../CreateModalComponent'
import './mentions.css'

import Tooltip from '../../../../../sharedComponent/CustomTooltip/Tooltip'
export default function Prompts({
  questionType,
  description,
  id,
  onQuestionEdit,
  onDeleteQuestion,
  position,
  tagList,
  continueCall,
  questionLength,
}: any) {
  const [readOnly, setReadOnly] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [question, setQuestion] = useState(description)
  const [isYESNO, setIsYESNO] = useState(questionType === 'YESNO' || questionType === 'BOTH_OPTION')
  const [isDTMF, setIsDTMF] = useState(questionType === 'DTMF' || questionType === 'BOTH_OPTION')
  const [continueForNO, setContinueForNo] = useState(continueCall)
  const [isVoiceResponse, setIsVoiceResponse] = useState(questionType === 'VOICE_RESPONSE')
  const inputField = useRef() as React.MutableRefObject<HTMLInputElement>
  const mentionsRef = useRef<any>()
  useEffect(() => {
    if (!readOnly) {
      inputField.current.readOnly = readOnly
      inputField.current.focus()
    } else {
      inputField.current.readOnly = readOnly
    }
  }, [readOnly])
  useEffect(() => {
    if (!description) {
      setReadOnly(false)
    }
  }, [])
  useEffect(() => {
    if (isYESNO && isDTMF) {
      onQuestionEdit(question, 'BOTH_OPTION', id, continueForNO)
    } else if (isYESNO) {
      onQuestionEdit(question, 'YESNO', id, continueForNO)
    } else if (isDTMF) {
      onQuestionEdit(question, 'DTMF', id, continueForNO)
    } else if (isVoiceResponse) {
      onQuestionEdit(question, 'VOICE_RESPONSE', id, continueForNO)
    } else if (!isYESNO && !isDTMF && !isVoiceResponse) {
      onQuestionEdit(question, 'SPEECH_ONLY', id, continueForNO)
    }
  }, [isYESNO, isDTMF, isVoiceResponse])

  const handleOnchange = (e: any) => {
    console.log('value', e.target.value)
    e.target.value ? setHasError(false) : setHasError(true)
    setQuestion(e.target.value)
    onQuestionEdit(question, questionType, id, continueForNO)
  }

  useEffect(() => {
    onQuestionEdit(question, questionType, id, continueForNO)
  }, [continueForNO])

  useEffect(() => {
    inputField.current.onblur = (e: any) =>
      e.target.value
        ? (setHasError(false),
          setReadOnly(true),
          onQuestionEdit(question, questionType, id, continueForNO))
        : (setHasError(true), setReadOnly(false))
  }, [question])

  const handleCheckboxChange = (checkboxType: string) => {
    if (checkboxType === 'isYESNO') {
      setIsYESNO((prev) => !prev)
      if (isYESNO || isDTMF) {
        // setIsDTMF(false);
        setIsVoiceResponse(false)
      }
    } else if (checkboxType === 'isDTMF') {
      setIsDTMF((prev) => !prev)
      if (isYESNO || isDTMF) {
        // setIsYESNO(false);
        setIsVoiceResponse(false)
      }
    } else if (checkboxType === 'isVoiceResponse') {
      setIsVoiceResponse((prev: any) => !prev)
      if (isVoiceResponse) {
        setIsYESNO(false)
        setIsDTMF(false)
      }
    }
  }

  return (
    <div>
      <div className='bg-f4f4f4 p-5 rounded-3 mb-1 drag-icon'>
        <div className='d-flex gap-4 align-items-center'>
          <div
            className='bg-gray-700 p-2 w-30px h-30px text-center text-white'
            style={{borderRadius: '6px'}}
          >
            {position}
          </div>
          <div ref={mentionsRef} className='mentions-cover w-100'>
            <MentionsInput
              value={question}
              onChange={(e) => handleOnchange(e)}
              inputRef={inputField}
              placeholder='use the { symbol to add tags'
              className='mentions mentions-override'
              onKeyUp={(e) => {
                e.stopPropagation()
                console.log(e)
                mentionsRef.current
                  .querySelector('.mentions__suggestions__item--focused')
                  ?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'nearest',
                  })
              }}
            >
              <Mention
                displayTransform={(id) => `${id}`}
                trigger='{'
                markup='[__id__]'
                data={tagList.map((tag: ITagList) => {
                  return {id: tag.value.slice(1, -1), display: tag.value}
                })}
                className='mentions__mention'
              />
            </MentionsInput>
          </div>

          <button className='btn btn-icon'>
            <img src={deleteButton} onClick={() => onDeleteQuestion(id)} alt='delete' />
          </button>
          <button className='btn btn-icon'>
            <img src={editButton} onClick={() => setReadOnly(false)} alt='delete' />
          </button>
        </div>
        <div className='form-check form-check-script form-check-custom form-check-solid mt-5 ms-12 script-modal'>
          <input
            className='form-check-input ms-5'
            type='checkbox'
            id='isVoiceResponse'
            checked={isVoiceResponse}
            // onChange={() => setIsVoiceResponse((prev: any) => !prev)}
            onChange={() => handleCheckboxChange('isVoiceResponse')}
            disabled={isYESNO || isDTMF}
          />
          <label className='form-check-label' htmlFor='SpeechOnly'>
            Voice Response
          </label>
          <Tooltip
            text='Select this for transcribing any customer response, Speech Only. For Live Agent, this will allow the agent to type an answer'
            isLast={questionLength === position && position !== 1}
          />

          <input
            className='form-check-input ms-5'
            type='checkbox'
            checked={isYESNO}
            onChange={() => handleCheckboxChange('isYESNO')}
            // onChange={() => setIsYESNO((prev) => !prev)}
            id='YESNO'
            disabled={isVoiceResponse}
          />
          <label className='form-check-label' htmlFor='YES'>
            Yes/No
          </label>
          <Tooltip
            text='Select this for transcribing any customer response, including Yes or No'
            isLast={questionLength === position && position !== 1}
          />

          <input
            className='form-check-input ms-5'
            type='checkbox'
            id='continueCall'
            checked={continueForNO}
            onChange={() => setContinueForNo((prev: any) => !prev)}
          />
          <label className='form-check-label' htmlFor='DTMF'>
            Continue for No
          </label>
          <Tooltip
            text='Select this if (a) selected Yes/NO, and (b) call should continue if customer responded with NO. This is helpful for prompts where NO response is not critical for TPV. For Ex. if a customer responded with NO about question releated to receiving affiliate marketing offers'
            isLast={questionLength === position && position !== 1}
          />

          <input
            className='form-check-input ms-5'
            type='checkbox'
            id='DTMF'
            checked={isDTMF}
            onChange={() => handleCheckboxChange('isDTMF')}
            // onChange={() => setIsDTMF((prev) => !prev)}
            disabled={isVoiceResponse}
          />
          <label className='form-check-label' htmlFor='DTMF'>
            DTMF
          </label>
          <Tooltip
            text='Select this for recording customer numerical response using telephone keypad. This is for Digital IVR only.'
            isLast={questionLength === position && position !== 1}
          />
        </div>
      </div>
      {hasError && <div className='text-danger ps-3'>Please provide a question</div>}
    </div>
  )
}
